var map = {
	"./cont3.png": 8132,
	"./interiorvillaoutfit.jpg": 8837,
	"./interirorofficeoutfit.jpg": 5897,
	"./interirorshopoutfit.jpg": 2145,
	"./pro1.webp": 8214,
	"./pro2.webp": 6903
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6457;